import type { MessageSchema } from '~/i18n/locales/locales.model'

export default function useL10n() {
  const { t, te, locale, setLocale } = useI18n<{ message: MessageSchema }>()

  return { t, te, locale, setLocale }
}
